import { render, staticRenderFns } from "./name-input-page.vue?vue&type=template&id=48bdd21f&"
import script from "./name-input-page.vue?vue&type=script&lang=js&"
export * from "./name-input-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports